import { each } from '@formily/shared';
export var formatVue3VNodeData = function (data) {
    var newData = {};
    each(data, function (value, key) {
        if (key === 'on' || key === 'nativeOn') {
            if (value) {
                each(value, function (func, name) {
                    var eventName = "on".concat(key === 'on' ? name[0].toUpperCase() : name[0]).concat(name.slice(1));
                    newData[eventName] = func;
                });
            }
        }
        else if (key === 'attrs' || key === 'props' || key === 'domProps') {
            Object.assign(newData, value);
        }
        else {
            newData[key] = value;
        }
    });
    return newData;
};
//# sourceMappingURL=formatVNodeData.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/utils/formatVNodeData.js
// module id = null
// module chunks = 